import getRandomInt from '../functions/getRandomInt';
//import getRandomIntArray from '../functions/getRandomIntArray';
import uqnJoin from '../functions/uqnJoin';
export default function random(type) {
    if (typeof type === "undefined" || type == 0) {
        type = getRandomInt(1, 4); // TODO: change this
    }
    if (type > 0 && type < 5) {
        const a = getRandomInt(1, 9);
        const sign = getRandomInt(0, 1);
        return uqnJoin([type, a, sign]);
    }
    else {
        throw "type out of bounds";
    }
}
